import axios from './financeiroApi';

const getPath = () => '/api/v1/backend/imovel';

const imovelApi = {
  get: async (params) => {
    return axios.get(getPath(), { params });
  },

  buscarPorId: async (id) => {
    return axios.get(`${getPath()}/${id}`);
  },

  post: async (imovel) => {
    return axios.post(getPath(), imovel);
  },

  put: async (id, imovel) => {
    return axios.put(`${getPath()}/${id}`, imovel);
  },

  delete: async (filtro) => {
    return axios.delete(getPath(), { data: filtro });
  },
};

export default imovelApi;
